<a *ngIf="this.userRequired"
   class="business-navbar__items"
   (click)="switchPage(null, false, {'productId': productId}, $event)"
   [class.business-navbar__items--active]="isActive$ | async"
   [style.padding-left.px]="calcIndentation(indentation)"
   [attr.disabled]="true">
    <ng-content *ngTemplateOutlet="navItem"></ng-content>
</a>

<a *ngIf="!this.userRequired && ((curServiceProviderId | async) !== serviceProviderId)"
   [href]="formattedUrl | async"
   class="business-navbar__items"
   (click)="switchPage(formattedUrl, false, {'productId': productId}, $event)"
   [class.business-navbar__items--active]="isActive$ | async"
   [style.padding-left.px]="calcIndentation(indentation)">
    <ng-content *ngTemplateOutlet="navItem"></ng-content>
</a>

<a *ngIf="!this.userRequired && ((curServiceProviderId | async) === serviceProviderId)"
   [routerLink]="formattedPath$ | async"
   class="business-navbar__items"
   (click)="switchPage(formattedPath$, true, {'route': path}, $event)"
   [class.business-navbar__items--active]="isActive$ | async"
   [style.padding-left.px]="calcIndentation(indentation)">
    <ng-content *ngTemplateOutlet="navItem"></ng-content>
</a>

<ng-template #navItem>
    <div class="business-navbar__item-wrapper">
        <span class="business-navbar__item" [title]="text$ | async">
            <atlas-icon *ngIf="showIcon" [matIcon]="icon" [logoUrl]="logoUrl"
                        [productName]="text$ | async"></atlas-icon>
            <span class="business-navbar__item__text">{{ text$ | async }}</span>
            <ng-content></ng-content>
        </span>
    </div>
    <atlas-chip *ngIf="!!chipContent" [text]="chipContent | translate:'Pro'" [isNavChip]="true"></atlas-chip>
    <span *ngIf="!!pinnable" class="business-navbar__item-pin"
          [ngClass]="{'business-navbar__item-pin--pinned': (isPinned$ | async), 'business-navbar__item-pin--disabled': !pinnable}"
          (click)="togglePin($event)">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path fill-rule="evenodd"
                  d="M19.083 1c0 1.018-1.424 1.907-3.541 2.382V11c2.926.652 4.958 2.086 4.958 3.751h-7.792V23h-1.416v-8.25H3.5c0-1.665 2.032-3.1 4.958-3.751V3.382C6.341 2.907 4.917 2.018 4.917 1h14.166z"/>
        </svg>
    </span>
</ng-template>
